module.exports = __webpack_public_path__ + "img/british-columbia.d71ccbe7.svg";